import poolTable from './_table.js'
import template from './index.pug'

export default Vue.extend({
  template: template(),
  components: {
    poolTable
  },
  data() {
    return {
      pools: [],
      meta: {}
    }
  },
  created() {
    this.$setPageTitle(this.$t('pool.index.title'))
    this.$setBreadcrumbs([
      {label: this.$t('breadcrumbs.pool.index'), route: {}}
    ])
  },
  methods: {
    loadPool(queryOptions = {}) {
      API.pool.index(queryOptions).then(({data, meta}) => {
        this.pools = data
        this.meta = meta
      })
    }
  }
})
